// Outbound links to the landing site (web3kurzus.hu).

// Where a FREE user activates TAG. The live landing opens the activation
// modal from the dashboard; the landing development branch adds
// /bonusz?aktivalas=1, which opens it directly — switch here once that ships.
export const TAG_ACTIVATION_URL = 'https://web3kurzus.hu/dashboard';

// The public page that explains how to get Kripto Start (TAG): partner
// exchange → deposit → UID on the dashboard. Shown to signed-out visitors.
export const TAG_HOWTO_URL = 'https://web3kurzus.hu/bonusz';

export const PRO_URL = 'https://web3kurzus.hu/pro';

// The Discord server (the same channel link as the landing dashboard's Discord tile, DISCORD_SERVER_URL).
export const DISCORD_SERVER_URL = 'https://discord.com/channels/999732072677658645';

// Free registration: the same path as the landing's "Kezdd el ingyen" buttons —
// the terminal's own magic-link screen (landing src/terminal.js, signed out).
export const REGISTER_URL = 'https://terminal.web3kurzus.hu';
// From the gyakorló demo: the same path, plus an allowlisted return target the
// terminal honours after the magic-link login (crypto-terminal src/utils/returnTo.js).
export const REGISTER_FROM_DEMO_URL = `${REGISTER_URL}/?w3k_return=/gyakorlo`;
// From the alakzatfelismerő demo: the same registration path, returning to /alakzatfelismero.
export const REGISTER_FROM_ALAKZAT_URL = `${REGISTER_URL}/?w3k_return=/alakzatfelismero`;
// From the gyertyaminta-felismerő demo: the same registration path, returning to /gyertyafelismero.
export const REGISTER_FROM_GYERTYA_URL = `${REGISTER_URL}/?w3k_return=/gyertyafelismero`;
